const forEveryoneDaySlugs = [
  'for-everyone-day-1',
  'for-everyone-day-2',
  'for-everyone-day-3',
  'for-everyone-day-4',
  'for-everyone-day-5',
  'for-everyone-videos',
];

export { forEveryoneDaySlugs };
